<template>
  <modal
    title="Light Package Guidelines"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="delete-illustration-wrapper ">
      <p class="py-3">Your light package MUST:</p>
      <ul class="list">
        <li>
          <img
            src="@/assets/images/icons/check.svg"
            alt="Delete illustration"
            style="width: 20px; margin: 0; margin-right: 14px"
          />
          Less than 32kg
        </li>
        <li>
            <img
            src="@/assets/images/icons/check.svg"
            alt="Delete illustration"
            style="width: 20px; margin: 0; margin-right: 14px"
          />
          Not Exceed 50cm X 40cm X 40cm</li>
        <li>
            <img
            src="@/assets/images/icons/check.svg"
            alt="Delete illustration"
            style="width: 20px; margin: 0; margin-right: 14px"
          />
          Be securely packed, sealed and ready for picked up</li>
      </ul>
    </div>

    <div>
      <b>Prohibited Items:</b>
      <p class="my-1">
        Recreational drugs, firearms, amunitions, dangerous, and illegal items
        are prohibited.
      </p>
      <p class="my-1 text-red-500">
        Violations may be reported to relevant authorities.
      </p>
      <p class="pt-3">
        For a full list of prohibited items, see our shipping policy.
      </p>
    </div>
    <div class="actions">
      <p class="ext-darkBlue font-semibold cursor-pointer" @click="closeModal">
        OK
      </p>
      <base-button
        text="Shipping Policy"
        :loading="loading"
      />
    </div>
  </modal>
</template>

<script>
// import Modal from "@/components/partials/Modal/index";
export default {
  components: {
    // Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },

  },
  data() {
    return {
      selectedModule: null,
      moduleOptions: [],
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 0 1rem;
  padding-top: 6em;
}
.actions button {
  padding: 0.25rem 0.75rem;
  border-radius: 3px;
}
.cancel-btn {
  color: #f57a4d;
}
.edit-btn {
  background: #f57a4d;
  color: #ffffff;
}
.delete-illustration-wrapper img {
  margin: 1rem auto;
  width: 4rem;
  height: auto;
}
.list li {
  @apply flex items-center my-5 justify-items-start;
}
.list {
  @apply mb-10;
}
</style>
